export default __webpack_public_path__ + "static/WhyteInktrap-Black-c2773731fb4260598e2ebb3a077faca6.woff2";